import React from 'react';
import './TermsModal.css';

export const TermsOfService = () => {
    return (
        <div className="terms-page-container" style={{ padding: '40px 20px', maxWidth: '800px', margin: '0 auto', color: 'white', fontFamily: 'Inter, sans-serif' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' }}>
                <h1 style={{ fontSize: '32px', margin: 0 }}>Terms of Service</h1>
                <a href="/" style={{ color: '#a855f7', textDecoration: 'none', fontWeight: 'bold' }}>← Back to Home</a>
            </div>
            
            <div style={{ background: 'rgba(30, 30, 50, 0.5)', padding: '30px', borderRadius: '16px', border: '1px solid rgba(255, 255, 255, 0.1)', lineHeight: '1.6' }}>
                <h3 style={{ marginTop: 0, color: '#d8b4fe' }}>1. Acceptance of Terms</h3>
                <p>
                    By creating an account and using You Don't Know You, you agree to these terms. If you do not agree, please do not use the service.
                    You must be at least 13 years old to use this service.
                </p>

                <h3 style={{ color: '#d8b4fe', marginTop: '24px' }}>2. Description of Service</h3>
                <p>
                    You Don't Know You provides personality assessments and insights based on AI analysis of user inputs, including handwriting samples and behavioral responses.
                    The service is provided for personal, non-commercial entertainment and self-discovery purposes only.
                </p>

                <h3 style={{ color: '#d8b4fe', marginTop: '24px' }}>3. User Accounts</h3>
                <p>
                    You are responsible for maintaining the confidentiality of your account credentials. You agree to notify us immediately of any unauthorized use of your account.
                </p>

                <h3 style={{ color: '#d8b4fe', marginTop: '24px' }}>4. Content and Entertainment Purposes Only</h3>
                <p>
                    Your brain profile, character card, and compatibility reports are generated by AI. 
                    <strong> They do not constitute professional psychological, medical, or life advice.</strong> 
                    Always consult qualified professionals for medical or psychological advice.
                </p>

                <h3 style={{ color: '#d8b4fe', marginTop: '24px' }}>5. Modifications</h3>
                <p>
                    We reserve the right to modify or discontinue the service at any time. We may also update these terms from time to time. 
                    Continued use of the service after changes constitutes acceptance of the updated terms.
                </p>

                <h3 style={{ color: '#d8b4fe', marginTop: '24px' }}>6. Limitation of Liability</h3>
                <p>
                    You Don't Know You and its creators shall not be liable for any indirect, incidental, special, or consequential damages resulting from the use or inability to use the service.
                </p>
                
                <p style={{ marginTop: '40px', opacity: 0.5, fontSize: '12px' }}>
                    Last Updated: May 2026
                </p>
            </div>
        </div>
    );
};
